import { useUnit } from 'effector-react';
import { CircleSlash2 } from 'lucide-react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { viewerModel } from 'entities/viewer';
import { WalletWithAccountId } from 'shared/api';
import { ConfirmModalProps, createConfirmModal, ModalFormActionIconProps } from 'shared/ui';
import { BlockWalletModel } from '../../model';

export const createBlockWalletModal = (model: BlockWalletModel) => {
	const ConfirmModal = createConfirmModal(model);

	const BlockWalletModal = forwardRef<HTMLDivElement, ConfirmModalProps>(({ ...props }, ref) => {
		const { t } = useTranslation();

		const [wallet] = useUnit([model.$modalData]);

		return (
			<ConfirmModal
				ref={ref}
				title={t('block-wallet.title')}
				cancelButtonProps={{
					children: t('block-wallet.cancel'),
				}}
				submitButtonProps={{
					variant: 'outline',
					children: t('block-wallet.block'),
				}}
				{...props}
			>
				{t('block-wallet.description', { name: wallet?.currency })}
			</ConfirmModal>
		);
	});

	const BlockWalletModalActionIcon = forwardRef<
		HTMLButtonElement,
		ModalFormActionIconProps<WalletWithAccountId>
	>(({ modalData, ...props }, ref) => {
		const viewerAccountId = useUnit(viewerModel.$accountId);

		return (
			<ConfirmModal.ActionIcon
				ref={ref}
				data-test-id='block-wallet-action-icon'
				variant='ghost-secondary'
				disabled={viewerAccountId === modalData.accountId}
				modalData={modalData}
				{...props}
			>
				<CircleSlash2 />
			</ConfirmModal.ActionIcon>
		);
	});

	return Object.assign(BlockWalletModal, {
		ActionIcon: BlockWalletModalActionIcon,
	});
};
